import axios from 'axios'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { _serverUrl2 } from '../../../config'
import { failed } from '../../../Utils/Alerts'
import DataSidebar from './DataSidebar'

export default function DataDashboard() {

    const [dStatics, setDStatics] = useState({
        totalNumber: '..',
        totalNumberWithRegion: []
    })

    const getInfosFromNode = async () => {
        let statics = {
            totalNumber: '..',
            totalNumberWithRegion: []
        }
        await axios.get(_serverUrl2 + '/data/getDataStatics/totalNumber')
            .then((res) => {
                if (res.data.status) {
                    statics.totalNumber = res.data.rows[0].val
                } else {
                    failed('Hata Oluştu.')
                }
            })
            .catch(() => {
                failed('Hata Oluştu.')
            })
        setDStatics(statics)
    }

    useEffect(() => {
        getInfosFromNode()

        return () => {

        }
    }, [])


    return (
        <div className='row'>

            <div className='col-sm-12'>
                <div className='textBox'>
                    <div className='content'>
                        Veri Yönetimi
                    </div>
                </div>
            </div>

            <div className='col-sm-12'>
                <DataSidebar page={0} />
            </div>

            <div className='col-sm-12'>
                <div className='textBox' style={{ color: 'black', fontSize: '14px' }} >
                    <div className='row'>
                        <div className='col-sm-12'>
                            <table className='table table-sm table-bordered table-hover' style={{ marginTop: '15px' }} >
                                <tbody>
                                    <tr>
                                        <th>Toplam Numarataj Verisi</th>
                                        <td>{dStatics.totalNumber}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
